const notificationBell = {
  title: "Notifications",
};

export default notificationBell;
